import React, {Component} from 'react';
import Slider from "react-slick";
import './slider.scss';
import {Link} from "react-router-dom";


class CarouselPage1 extends Component {

    constructor(props) {
        super(props);
        this.data = [
            {
                image: `/assets/images/general/pool-amenities.jpg`,
            },
            {
                image: `/assets/images/general/outside-amenities.jpg`,
            },
            {
                image: `/assets/images/general/parking-amenities.jpg`,
            }
        ]

        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);


        this.state = {
            active: this.data[0]
        }
    }

    next() {
        this.slider.slickNext();
    }

    previous() {
        this.slider.slickPrev();
    }

    slideChange = (old, index) => {
        this.setState({
            active: this.data[index]
        })
    }

    render() {
        const settings = {
            dots: false,
            arrows: false,
            infinite: true,
            speed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
        };

        return (
            <div className={'carousel1-wrap position-relative'}>
                <Slider ref={slide => (this.slider = slide)} {...settings} beforeChange={this.slideChange}>
                    {this.data.map((data, index) =>
                        <div className="slider-item" key={index}>
                            <img src={data.image} alt=""/>
                        </div>
                    )}
                </Slider>
                <div className="slider-content d-flex justify-content-end align-items-end flex-wrap">
                    <div className="navigation">
                        <button className="arrow-button arrow-prev" onClick={this.previous}>
                            Previous
                        </button>
                        <button className="arrow-button arrow-next" onClick={this.next}>
                            Next
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default CarouselPage1